import { inject } from '@angular/core';
import { CanActivateFn, CanMatchFn, Router } from '@angular/router';
import { AuthService } from '@core/services/auth.service';
import { map } from 'rxjs/operators';

/**
 * Runs during route recognition (before child canMatch / activation).
 * Guests never enter the workspace shell — avoids a blank ion-router-outlet
 * while canActivate UrlTree redirects race Ionic's initial navigation.
 */
export const authMatch: CanMatchFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  auth.purgeLegacyDemoStorage();
  if (!auth.hasToken()) {
    auth.logout();
    return router.createUrlTree(['/login']);
  }
  return true;
};

export const authGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  auth.purgeLegacyDemoStorage();

  // Require a real JWT — never trust an in-memory user alone (blocks demo sessions).
  if (!auth.hasToken()) {
    auth.logout();
    return router.createUrlTree(['/login']);
  }

  if (auth.currentUser()) {
    return true;
  }

  return auth.ensureSession().pipe(
    map((user) => (user ? true : router.createUrlTree(['/login']))),
  );
};
